/**
 * CandyBow: color option starts unselected; gallery shows all product media;
 * cart disabled until color is chosen.
 */
(function () {
  class CbdProductVariant {
    constructor(productInfo) {
      this.productInfo = productInfo;
      this.sectionId = productInfo.dataset.section;
      this.variantSelects = productInfo.querySelector('variant-selects[data-cbd-defer-color="true"]');
      if (!this.variantSelects) return;

      this.colorPosition = parseInt(this.variantSelects.dataset.cbdColorOptionPosition, 10);
      this.variants = this.parseJson(`CbdProductVariants-${this.sectionId}`);
      this.options = this.parseJson(`CbdProductOptions-${this.sectionId}`) || [];
      this.productForm = productInfo.querySelector('product-form');
      this.mediaGallery = productInfo.querySelector('media-gallery');
      this.placeholderText =
        this.variantSelects.dataset.cbdColorPlaceholder || '選択してください';
      this.selectOptionsText =
        window.variantStrings?.selectOptions || '商品を選択してください';

      this.init();
      CbdProductVariant.attachToVariantSelects(this.variantSelects);
      this.subscribeVariantChange();
    }

    parseJson(id) {
      const el = document.getElementById(id);
      if (!el?.textContent) return null;
      try {
        return JSON.parse(el.textContent);
      } catch {
        return null;
      }
    }

    init() {
      this.uncheckColorOptions();
      this.updateColorLegend();
      this.setCartPendingState(true);
      this.activateFirstGallerySlide();
      this.stripVariantFromUrl();
    }

    static attachToVariantSelects(variantSelects) {
      if (variantSelects.dataset.cbdDeferColor !== 'true' || variantSelects._cbdAttached) return false;
      variantSelects._cbdAttached = true;

      variantSelects.addEventListener(
        'change',
        (event) => {
          const instance = variantSelects._cbdInstance;
          if (!instance) return;

          const target = event.target;
          const isColorInput = instance.isColorOptionInput(target);

          variantSelects.updateSelectionMetadata(event);
          instance.updateColorLegend();

          event.stopImmediatePropagation();

          if (!instance.isColorSelected()) {
            if (isColorInput && target.checked) {
              instance.markColorSelected();
              instance.publishOptionChange(event, target);
              return;
            }
            if (!isColorInput) {
              instance.resolveVariantWithoutColor();
              instance.setCartPendingState(true);
            }
            return;
          }

          instance.markColorSelected();
          instance.publishOptionChange(event, target);
        },
        true
      );
      return true;
    }

    publishOptionChange(event, target) {
      const input = target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target: input,
          selectedOptionValues: this.variantSelects.selectedOptionValues,
        },
      });

      const variant = this.findVariantFromSelection();
      if (variant) {
        this.updateVariantInput(variant.id);
        this.setCartReadyState(variant);
      }
    }

    subscribeVariantChange() {
      if (typeof subscribe !== 'function') return;
      const sectionId = this.productInfo.dataset.section;
      this._variantChangeUnsub = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== sectionId) return;

        this.syncVariantSelectsElement();
        const variant = data.variant;

        if (!variant) {
          if (!this.isColorSelected()) this.setCartPendingState(true);
          return;
        }

        this.applyColorSelectionFromVariant(variant);
        this.markColorSelected();
        this.updateColorLegend();

        if (variant.featured_media?.id && this.mediaGallery?.setActiveMedia) {
          this.mediaGallery.setActiveMedia(`${this.sectionId}-${variant.featured_media.id}`, true);
        }

        this.setCartReadyState(variant);
      });
    }

    findVariantFromSelection() {
      if (!this.variants?.length) return null;
      const selected = this.getSelectedOptionValuesByPosition();

      return this.variants.find((variant) => {
        for (let index = 0; index < this.options.length; index++) {
          const position = index + 1;
          const key = `option${position}`;
          const selectedValue = selected[position];
          if (selectedValue && variant[key] !== selectedValue) return false;
        }
        return true;
      });
    }

    setCartReadyState(variant) {
      if (!this.productForm || !variant) return;
      const disabled = !variant.available;
      this.productForm.toggleSubmitButton(
        disabled,
        disabled ? window.variantStrings.soldOut : undefined
      );
      const paymentButton = this.productForm.querySelector('.shopify-payment-button');
      if (paymentButton) {
        if (disabled) paymentButton.setAttribute('hidden', 'hidden');
        else paymentButton.removeAttribute('hidden');
      }
    }

    syncVariantSelectsElement() {
      const variantSelects = this.productInfo.querySelector('variant-selects[data-cbd-defer-color="true"]');
      if (!variantSelects) return;
      this.variantSelects = variantSelects;
      variantSelects._cbdInstance = this;
      CbdProductVariant.attachToVariantSelects(variantSelects);
    }

    isColorOptionInput(target) {
      if (!target || !this.colorPosition) return false;
      const fieldset = target.closest('.product-form__input');
      if (!fieldset) return false;
      return fieldset.dataset.cbdColorOption === 'true';
    }

    isColorSelected() {
      if (!this.colorPosition) return true;
      const fieldset = this.variantSelects.querySelector('[data-cbd-color-option="true"]');
      if (!fieldset) return true;
      const select = fieldset.querySelector('select');
      if (select) return select.selectedIndex > 0 && select.value !== '';
      return !!fieldset.querySelector('input[type="radio"]:checked');
    }

    uncheckColorOptions() {
      const fieldset = this.variantSelects?.querySelector('[data-cbd-color-option="true"]');
      if (!fieldset) return;
      fieldset.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
        input.checked = false;
      });
      const select = fieldset.querySelector('select');
      if (select) {
        select.selectedIndex = 0;
      }
      fieldset.classList.add('cbd-color-option--unselected');
      fieldset.setAttribute('data-cbd-color-unselected', 'true');
    }

    markColorSelected() {
      const fieldset = this.variantSelects?.querySelector('[data-cbd-color-option="true"]');
      if (!fieldset) return;
      fieldset.classList.remove('cbd-color-option--unselected');
      fieldset.removeAttribute('data-cbd-color-unselected');
    }

    applyColorSelectionFromVariant(variant) {
      if (!variant || !this.colorPosition) return;
      const colorValue = variant[`option${this.colorPosition}`];
      if (!colorValue) return;

      const fieldset = this.variantSelects?.querySelector('[data-cbd-color-option="true"]');
      if (!fieldset) return;

      fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.checked = input.value === colorValue;
      });

      const select = fieldset.querySelector('select');
      if (select) {
        Array.from(select.options).forEach((option, index) => {
          if (option.value === colorValue) select.selectedIndex = index;
        });
      }
    }

    updateColorLegend() {
      const fieldset = this.variantSelects?.querySelector('[data-cbd-color-option="true"]');
      const legendValue = fieldset?.querySelector('[data-selected-value]');
      if (!legendValue) return;

      if (!this.isColorSelected()) {
        legendValue.textContent = this.placeholderText;
        return;
      }

      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked) {
        legendValue.textContent = checked.value;
        return;
      }

      const select = fieldset.querySelector('select');
      if (select?.selectedIndex > 0) {
        legendValue.textContent = select.value;
      }
    }

    getSelectedOptionValuesByPosition() {
      const values = {};
      this.variantSelects.querySelectorAll('[data-option-position]').forEach((fieldset) => {
        const position = parseInt(fieldset.dataset.optionPosition, 10);
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        if (checked) values[position] = checked.value;
        const select = fieldset.querySelector('select');
        if (select?.value) values[position] = select.value;
      });
      return values;
    }

    resolveVariantWithoutColor() {
      if (!this.variants?.length) return;
      const selected = this.getSelectedOptionValuesByPosition();
      const match = this.variants.find((variant) => {
        if (!variant.available) return false;
        for (let index = 0; index < this.options.length; index++) {
          const position = index + 1;
          if (position === this.colorPosition) continue;
          const key = `option${position}`;
          const selectedValue = selected[position];
          if (selectedValue && variant[key] !== selectedValue) return false;
        }
        return true;
      });
      const variant = match || this.variants.find((v) => v.available) || this.variants[0];
      if (variant) this.updateVariantInput(variant.id);
    }

    updateVariantInput(variantId) {
      this.productInfo.querySelectorAll(`#product-form-${this.sectionId}, #product-form-installment-${this.sectionId}`).forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        if (input) input.value = variantId;
      });
    }

    setCartPendingState(pending) {
      if (!this.productForm || !pending) return;
      this.productForm.toggleSubmitButton(true, this.selectOptionsText);
      this.productForm.querySelector('.shopify-payment-button')?.setAttribute('hidden', 'hidden');
    }

    activateFirstGallerySlide() {
      const firstSlide = this.productInfo.querySelector(
        `#Slider-Gallery-${this.sectionId} .product__media-item`
      );
      if (!firstSlide || !this.mediaGallery?.setActiveMedia) return;
      const mediaId = firstSlide.dataset.mediaId;
      if (mediaId) this.mediaGallery.setActiveMedia(mediaId, false);
    }

    stripVariantFromUrl() {
      if (this.productInfo.dataset.updateUrl === 'false') return;
      const url = new URL(window.location.href);
      if (url.searchParams.has('variant')) {
        url.searchParams.delete('variant');
        window.history.replaceState({}, '', url.pathname + url.search);
      }
    }

    get productInfoSectionId() {
      return this.sectionId;
    }
  }

  function initProductInfo(productInfo) {
    if (!productInfo.querySelector('variant-selects[data-cbd-defer-color="true"]')) return;
    if (productInfo.dataset.cbdVariantInit === 'true') return;
    productInfo.dataset.cbdVariantInit = 'true';

    const variantSelects = productInfo.querySelector('variant-selects[data-cbd-defer-color="true"]');
    const instance = new CbdProductVariant(productInfo);
    variantSelects._cbdInstance = instance;

    productInfo.addEventListener('product-info:loaded', () => {
      const vs = productInfo.querySelector('variant-selects[data-cbd-defer-color="true"]');
      if (!vs || vs._cbdAttached) return;
      vs._cbdInstance = instance;
      CbdProductVariant.attachToVariantSelects(vs);
      if (!instance.isColorSelected()) {
        instance.setCartPendingState(true);
      }
    });
  }

  function boot() {
    document.querySelectorAll('product-info').forEach(initProductInfo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.CbdProductVariant = CbdProductVariant;
})();
